import { render, staticRenderFns } from "./TableButtons.vue?vue&type=template&id=daddf88c&scoped=true&"
import script from "./TableButtons.vue?vue&type=script&lang=js&"
export * from "./TableButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daddf88c",
  null
  
)

export default component.exports